import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {Timeline, TimelineLite} from "gsap"
import {DungeonQuestSymbolUtil} from "../../../utils/DungeonQuestSymbolUtil";
import {StateMatrix} from "../../../utils/StateMatrix";
import {DungeonQuestHelper} from "../../bigSymbols/DungeonQuestHelper";
import {DungeonQuest} from "../../DungeonQuest";
import {DungeonQuestGameConfig, DungeonQuestGameMode, DungeonQuestSymbols} from "../../DungeonQuestGameConfig";
import {DungeonQuestSound} from "../../DungeonQuestSound";
import {ColossalSymbolInfo, DungeonQuestParsedGameData} from "../../server/data/DungeonQuestParsedGameData";
import {DungeonQuestParsedInitData} from "../../server/data/DungeonQuestParsedInitData";
import {DungeonQuestModeData} from "../../server/DungeonQuestModeData";
import {DungeonQuestFreeSpinFeatureView} from "./DungeonQuestFreeSpinFeatureView";

import {DungeonQuestFreeSpinIntroView} from "./DungeonQuestFreeSpinIntroView";

/**
 * Class description
 *
 * Created: 2018-05-02
 * @author jonas
 */
export class DungeonQuestFreeSpinFeatureController extends ReelStopPresentationController {
    private _overlayReels:string[][];
    private _overlayReelsBeforeSpin:string[][];
    private _overlayReelsAfterSpin:string[][];
    private _symbolToBeTransformed:string;
    private _newOverlayMatrix:StateMatrix<string>;
    private _overlayView:DungeonQuestFreeSpinFeatureView;
    private _symbolData:ColossalSymbolInfo;
    private _newPositions:[number, number][];
    private _beforePositions:[number, number][];
    private _allOverlayPositions:[number, number][];
    private _freespinIntroView:DungeonQuestFreeSpinIntroView;
    private _freespinsRemaining:number;
    private _freespinsPlayed:number;
    private _mode:string;
    private _nextMode:string;

    private static SYMBOLS_TO_TRANSFORM_ORDER:string[] = [
        DungeonQuestSymbols.L4,
        DungeonQuestSymbols.L3,
        DungeonQuestSymbols.L2,
        DungeonQuestSymbols.L1
    ];

    constructor(index:number, name:string) {
        super(index, name);
        this._overlayView = new DungeonQuestFreeSpinFeatureView();
        this._freespinIntroView = new DungeonQuestFreeSpinIntroView();
        this._freespinsPlayed = 0;
        this._allOverlayPositions = [];
        DungeonQuest.freeSpinFeatureController = this;

        //DebugKeyPressTrigger.addTrigger("t", ()=>this.getPreSpinAnimation());
    }

    protected addFeatureEventHandlers() {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeStart());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.IDLE, (event:GameEvent) => this.onIdle());
        EventHandler.addEventListener(this, WinPresentationEvent.ALL_PRESENTATIONS_COMPLETED, (event:GameEvent) => this.onAllWinsComplete());
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
    }

    private onIdle() {
        if(this._mode == DungeonQuestGameMode.FREESPIN && this._nextMode == DungeonQuestGameMode.NORMAL) {
            this.getEndAnimation();
        }
    }

    private setupBaseData(data:ParsedGameData | ParsedInitData) {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        this._freespinsRemaining = (<DungeonQuestParsedGameData | DungeonQuestParsedInitData>data).freespinsRemaining || 0;
        this._freespinsPlayed = (<DungeonQuestParsedGameData | DungeonQuestParsedInitData>data).freespinsPlayed || 0;
        this._overlayReelsBeforeSpin = (<DungeonQuestParsedGameData | DungeonQuestParsedInitData>data).overlaySymbolsBeforeSpin;
    }

    protected onInitDataParsed(data:ParsedInitData):void {
        this.setupBaseData(data);
        this._symbolToBeTransformed = DungeonQuestFreeSpinFeatureController.SYMBOLS_TO_TRANSFORM_ORDER[this._freespinsPlayed];
        const matrix = new StateMatrix<string>(5, 7, [0, 6], "");
        matrix.init(this._overlayReelsBeforeSpin);
        this._allOverlayPositions = matrix.getAllCoordinatesWithState(DungeonQuestSymbols.W);
    }

    protected parseFeatureGameData(data:ParsedGameData):void {
        this.setupBaseData(data);
        this._symbolToBeTransformed = (<DungeonQuestParsedGameData>data).symbolToBeTransformed;

        this._overlayReels = (<DungeonQuestParsedGameData>data).overlayReels;
        this._overlayReelsAfterSpin = (<DungeonQuestParsedGameData>data).overlaySymbolsAfterSpin;


        const before = new StateMatrix<string>(5, 7, [0, 6], "");
        before.init(this._overlayReelsBeforeSpin);

        this._beforePositions = before.getAllCoordinatesWithState(DungeonQuestSymbols.W);

        this._newOverlayMatrix = new StateMatrix<string>(5, 7, [0, 6], "");
        this._newOverlayMatrix.init(this._overlayReelsAfterSpin);
        this._allOverlayPositions = this._newOverlayMatrix.getAllCoordinatesWithState(DungeonQuestSymbols.W);

        //subtract the old ones.
        this._newOverlayMatrix.setStatesAt(before.getAllCoordinatesWithState(DungeonQuestSymbols.W), "");
        this._newPositions = this._newOverlayMatrix.getAllCoordinatesWithState(DungeonQuestSymbols.W);

        this._symbolData = {
            entireSymbolVisible : true,
            position : [2, 3],
            size : 1,
            symbol : "WSticky",
            transformTriggered : true
        };
    }

    private onRestore() {
        this.onAllWinsComplete();
        SlotGame.keypad.setZeroBetSpinCounter(this._freespinsRemaining);
    }

    private onAllWinsComplete() {
        if(this._mode == DungeonQuestGameMode.FREESPIN && this._nextMode == DungeonQuestGameMode.FREESPIN) {
            this.addOverlays();
        } else {
            this._overlayView.clearAllOverlaySymbols();
            this._freespinsPlayed = 0;
        }

    }

    private onBeforeStart() {
        /*        if(this._nextMode != FifthElementGameMode.FREESPIN) {
                    this._overlayView.clearAllOverlaySymbols();
                    this._freespinsPlayed = 0;
                }*/
    }

    private addOverlays() {
        this._overlayView.addOverlays(this._allOverlayPositions);
        const symbols = DungeonQuestSymbolUtil.getSymbolsAtPositions(this._allOverlayPositions);
        for(let symbol of symbols) {
            symbol.replaceWith(DungeonQuestSymbols.NONE, symbol.reelId, DungeonQuestGameConfig.instance.SYMBOL_STATES.hidden);
        }
    }

    public preSpinHasWin() {
        //This happens before data is received so nextMode will be mode once data arrives.
        return this._nextMode == DungeonQuestGameMode.FREESPIN;
    }

    protected hasWin() {
        return this._mode == DungeonQuestGameMode.FREESPIN;
    }

    public getPreSpinAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => DungeonQuest.soundPlayer.switchToFsMusic()
        ]);
        tl.add(this.getIntroFeatureAnimation());

        return tl;
    }

    private getEndAnimation():TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => DungeonQuest.reelAreaEffectController.switchBackground(DungeonQuestGameMode.NORMAL));
        tl.add(() => DungeonQuest.reelAreaEffectController.getHideBackgroundTint());
        tl.add(() => DungeonQuest.reelAreaEffectController.stopReelAreaAttention());
        tl.add(() => DungeonQuest.soundPlayer.switchToMainMusic());

        return tl;
    }

    protected getIntroFeatureAnimation():TimelineLite {
        this._freespinIntroView.update(this._freespinsPlayed, this._freespinsRemaining);
        const tl = new TimelineLite();
        tl.add(() => this._freespinIntroView.setSymbolsToCorrectStateBeforeUpdate());
        if(this._freespinsPlayed == 0) {
            tl.add(() => SlotGame.sound.playEffect(DungeonQuestSound.FS_INTRO));
        }
        tl.add([
            () => DungeonQuest.reelAreaEffectController.switchBackground(DungeonQuestGameMode.FREESPIN),
            this._freespinIntroView.show()
        ], "+=0.6");

        if(this._freespinsPlayed == 0) {
            tl.add(this._freespinIntroView.getIntroAnimation());
        }

        tl.add(this._freespinIntroView.getUpdateSymbolAnimation());

        const removeIntroOffset = -0.6;
        tl.add(  ()=> SlotGame.keypad.setZeroBetSpinCounter(this._freespinsRemaining));
        tl.add(() => DungeonQuest.reelAreaEffectController.startReelAreaAttention(DungeonQuestHelper.getSymbolColor(this._symbolToBeTransformed)), tl.totalDuration() + removeIntroOffset);
        tl.add(() => this._freespinIntroView.hide(), tl.totalDuration() + removeIntroOffset);
        tl.add(() => DungeonQuestModeData.instance.activateHighlightedReels());


        return tl;
    }


    public onReelBounce(data:IReelStoppedData):void {
        if(!this.hasWin()) {
            return;
        }

        const tl:TimelineLite = new TimelineLite();
        DungeonQuest.soundPlayer.playTransformExtraLandingSound(data.reelId);

        const attentionAnimations:Timeline[] = this.getSymbolOverlayAttentionAnimations(data.reelId, this._newPositions);
        if(attentionAnimations.length > 0) {
            DungeonQuest.soundPlayer.playTransformSymbolAttention(data.reelId);
            tl.add(attentionAnimations, 0, "start", 0);
        }

    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(data.reelId != 4 || !this.hasWin()) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }
        const tl:TimelineLite = new TimelineLite();

        const symbolReplaceStateChange:TimelineLite = new TimelineLite();
        for(let position of this._beforePositions) {
            const symbol:StateReelSymbol = Reels.getSymbol(position[0], position[1])!;
            if(symbol != null) {
                symbolReplaceStateChange.add(() => symbol.replaceWith(DungeonQuestSymbols.W_STICKY, symbol.reelId), 0);
            }
        }


        tl.add(() => DungeonQuest.reelAreaEffectController.getHideBackgroundTint());
        tl.add(symbolReplaceStateChange);
        tl.add(() => this._overlayView.clearAllOverlaySymbols());
        tl.add(() => DungeonQuest.reelAreaEffectController.getHideBackgroundTint());
        tl.add(() => DungeonQuest.reelAreaEffectController.stopReelAreaAttention());

        if(this._newPositions.length > 0) {
            tl.add(DungeonQuest.symbolTransformView.getNewShockWaveTransform(this._symbolData, this._newPositions));
            tl.add(() => SlotGame.sound.fadeEffect(DungeonQuestSound.FS_TURN_WILD, 1, tl.totalDuration() - 1.35));
        }

        if(this._nextMode != DungeonQuestGameMode.FREESPIN) {
            tl.add(() => this._freespinIntroView.hide());
        }

        tl.add(() => this.dispatchCompleteEvent(data.reelId));

    }

    protected getSymbolOverlayAttentionAnimations(reelId:number, overlayPositions:[number, number][]):Timeline[] {
        const symbols:StateReelSymbol[] = [];

        for(let position of overlayPositions) {
            if(position[0] == reelId) {
                const symbol = Reels.getSymbol(position[0], position[1]);
                if(symbol) {
                    symbols.push(symbol)
                }
            }
        }

        return DungeonQuestSymbolUtil.getSymbolStateAnimations(symbols, DungeonQuestGameConfig.instance.SYMBOL_STATES.attention);
    }


}